import React from 'react';
import {IconButton, Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {DownloadContainer} from './styles';
import {Loading} from '../Loading/Loading';
import {DownloadDocumentProps} from './types';

export function DownloadDocument({
	label,
	handleAction,
	isLoading,
	dataTagId,
}: DownloadDocumentProps) {
	const theme = useTheme();

	return (
		<DownloadContainer>
			<Typography>{label}</Typography>
			<IconButton onClick={handleAction} disabled={isLoading} data-tag-id={dataTagId}>
				{isLoading ? (
					<Loading size={24} fullWidth={false} color="inherit" />
				) : (
					<Icon name="download" color={theme.palette.primary.main} />
				)}
			</IconButton>
		</DownloadContainer>
	);
}
